import "@/app/style/videoGallery.scss";
import { ValidVideo, VideoSource } from "@/app/utils/class/common/video";
import VideoPlayer from "./VideoPlayer";
import { useEffect, useState } from "react";
import { Grid, Dialog, Modal, Skeleton } from "@mui/material";
import styled from "styled-components";
import { text_size } from "@/app/utils/MixinSize";
import { defaultValue, generateAdobeDataRaceNo } from "@/app/utils/Common";
import { generateVideoSource, generateVideoUrl, validateVideo } from "@/app/utils/Video";
import VideoThumbnail, { VideoInfo, generateVideoInfo } from "./VideoThumbnail";
import { useMyContext } from "@/app/utils/MyContext";
import { VideoWAData } from "@/app/ui/Common/VideoPlayer/player";

const generateMockData = (title: string, thumbnail: string, akamaiKey: string) => {
  return {
    videoTitle: {
      value: title,
    },
    videoThumbnail: {
      src: thumbnail,
    },
    videoURL: {
      value: akamaiKey
    }
  }
}

const mockData = [
  generateMockData("Highlights of Sussex Stakes Day", "https://res.hkjc.com/campaigns/wp-content/uploads/sites/789/video-special_2024-york_PrixDuJockeyClub2024.jpg", "/special/2024/2024-york/PrixDuJockeyClub2024/chi/special_2024-york_PrixDuJockeyClub2024_chi"),
  generateMockData("Track Analysis of Goodwood Cup (3200m)", "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRiMSBkeOPAIuiJ9f8Eh8cjrGvJoYOqMk4GFA&s", "/special/2024/2024-york/PrixDuJockeyClub2024/chi/special_2024-york_PrixDuJockeyClub2024_eng"),
  generateMockData("", "", ""),
  generateMockData("Track Analysis of Goodwood Cup (3200m)Track Analysis of Goodwood Cup (3200m)Track Analysis of Goodwood Cup (3200m)Track Analysis of Goodwood Cup (3200m)", "https://d537y3nbkeq75.cloudfront.net/22/52445040.jpg", "/special/2024/2024-royalascot/LockingeStakes2024/eng/special_2024-royalascot_LockingeStakes2024_eng"),
  generateMockData("Interview with Trainer Alice Haynes", "https://d537y3nbkeq75.cloudfront.net/22/52517031.jpg", "/special/2024/2024-royalascot/LockingeStakes2024/eng/special_2024-royalascot_LockingeStakes2024_chi"),
  generateMockData("", "", "/special/2024/2024-york/PrixDuJockeyClub2024/chi/special_2024-york_PrixDuJockeyClub2024_chi"),
  generateMockData("Interview with Andrea Atzeni (Jockey of VANDEEK)", "https://res.hkjc.com/campaigns/wp-content/uploads/sites/789/Race-Replay_CHI_1200-675.jpg", ""),
  generateMockData("Highlights of Goodwood Cup Day", "https://res.hkjc.com/campaigns/wp-content/uploads/sites/789/video-special_2024-york_KEVIIStakes2024.jpg", "/special/2024/2024-royalascot/LockingeStakes2024/eng/special_2024-royalascot_LockingeStakes2024_eng"),
  generateMockData("Track Analysis of Nassau Stakes (2000m)", "", "/special/2024/2024-royalascot/LockingeStakes2024/eng/special_2024-royalascot_LockingeStakes2024_chi"),
  generateMockData("The going of Goodwood racecourse", "", "/special/2024/2024-york/PrixDuJockeyClub2024/chi/special_2024-york_PrixDuJockeyClub2024_chi"),
  generateMockData("Test", "", "/special/2024/2024-york/PrixDuJockeyClub2024/chi/special_2024-york_PrixDuJockeyClub2024_eng"),
  generateMockData("Test 123", "", "/special/2024/2024-royalascot/LockingeStakes2024/eng/special_2024-royalascot_LockingeStakes2024_eng"),
  generateMockData("", "", "/special/2024/2024-york/PrixDuJockeyClub2024/chi/special_2024-york_PrixDuJockeyClub2024_chi"),
  generateMockData("Interview with Andrea Atzeni (Jockey of VANDEEK)", "https://res.hkjc.com/campaigns/wp-content/uploads/sites/789/Race-Replay_CHI_1200-675.jpg", ""),
  generateMockData("Highlights of Goodwood Cup Day", "https://res.hkjc.com/campaigns/wp-content/uploads/sites/789/video-special_2024-york_KEVIIStakes2024.jpg", "/special/2024/2024-royalascot/LockingeStakes2024/eng/special_2024-royalascot_LockingeStakes2024_eng"),
  generateMockData("Track Analysis of Nassau Stakes (2000m)", "", "/special/2024/2024-royalascot/LockingeStakes2024/eng/special_2024-royalascot_LockingeStakes2024_chi"),
  generateMockData("The going of Goodwood racecourse", "", "/special/2024/2024-york/PrixDuJockeyClub2024/chi/special_2024-york_PrixDuJockeyClub2024_chi"),
  generateMockData("Test", "", "/special/2024/2024-york/PrixDuJockeyClub2024/chi/special_2024-york_PrixDuJockeyClub2024_eng"),
  generateMockData("Test 123", "", "/special/2024/2024-royalascot/LockingeStakes2024/eng/special_2024-royalascot_LockingeStakes2024_eng"),
  generateMockData("Test 1234", "", "/special/2024/2024-royalascot/LockingeStakes2024/eng/special_2024-royalascot_LockingeStakes2024_chi"),
];

const DivMobileHeader = styled.div`
  display: flex;
  width: 100%;
  height: 48px;
  line-height: 48px;
  background: linear-gradient(180deg, #012c60 0%, #01336f 100%);
`;
const DivMobileHeaderBack = styled.div`
  width: 84px;
  div {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  padding: 0 0 0 8px;
  display: flex;
  align-items: center;
`;
const DivMobileHeaderTitle = styled.div`
  display: flex;
  width: 100%;
  color: #ffffff;
  ${text_size(18)}
  font-weight: 700;
  text-align: center;
  justify-content: center;
`;

interface VideoGalleryProps {
  isMobile: boolean;
  title: string;
  open?: boolean;
  videoUrls?: string[];
  enableShare?: boolean;
  onClose: () => any;
  data?: any;
  useMock?: boolean;
}

const VideoGallery = (props: VideoGalleryProps) => {
  const {state: myContextState} = useMyContext();
  const [isLoading, setIsLoading] = useState(true);
  const [isOpenModal, setIsOpenModal] = useState(true);
  const [isOpenVideo, setIsOpenVideo] = useState(false);
  const [selectedSources, setSelectedSources] = useState([] as VideoSource[]);
  const [selectedVideoTitle, setSelectedVideoTitle] = useState('');
  const [selectedWAData, setSelectedWAData] = useState<VideoWAData|undefined>(undefined);
  const [videoValidation, setVideoValidation] = useState([] as ValidVideo[]);
  const [videoData, setVideoData] = useState<(VideoInfo|undefined)[]>([]);
  const [urls, setUrls] = useState([] as ({sd?: string, hd?: string}|null)[]);

  useEffect(()=>{
    handleClose();
    const data = props.useMock ? mockData : props.data
    setVideoData(data?.map((d: any, i: number)=>generateVideoInfo(d.videoTitle?.value, d.videoThumbnail?.src, false, d.videoURL?.value)));
    validateVideos(data).then((res?: ValidVideo[])=>{
      const newData = data?.map((d: any, i: number)=>generateVideoInfo(d.videoTitle?.value, d.videoThumbnail?.src, res?.[i]?.hasVideo(), d.videoURL?.value))
      setVideoData(newData);
      setIsLoading(false);
    });
  }, [props.data])

  const validateVideos = async (data: any[]) => {
    if (!data || data.length === 0) {
      setVideoValidation([]);
      setUrls([]);
      return;
    };
    const videosUrls = data?.map((item: any)=>{
      if (item === undefined) return null;
      return generateVideoUrl(item.videoURL?.value || '')
    })
    const newVideoValidation =  await Promise.all<Promise<ValidVideo>[]>(videosUrls?.map(async (url: any)=>validateVideo(url)));
    setVideoValidation(newVideoValidation);
    setUrls(videosUrls);
    return newVideoValidation;
  }

  const openVideoPlayer = (e:any, idx: number) => {    
    e.preventDefault();
    setSelectedWAData({
      raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
      contentTitle: videoData[idx]?.title,
    });
    setSelectedVideoTitle(defaultValue(videoData[idx]?.title, ''));
    setSelectedSources(generateVideoSource(urls[idx]?.sd, urls[idx]?.hd, videoValidation[idx]));
    setIsOpenVideo(true);
  }

  const handleClose = () => {
    setIsOpenVideo(false);
    setSelectedWAData(undefined);
    setSelectedVideoTitle('');
    setSelectedSources([]);
  }

  const handleModalClose = () => {
    setIsOpenModal(false);
    setIsLoading(true);
    props.onClose();
  }
  return (
  <>
    {
      props.isMobile ? (
        <Modal open={isOpenModal} className="videoGalleryModal">
          <div className="videoGalleryContainerM">
            <DivMobileHeader>
              <DivMobileHeaderBack>
                <div>
                  <img src={`${myContextState.assetPrefix}/navigate_before.svg`} onClick={handleModalClose}/>
                </div>
              </DivMobileHeaderBack>
              <DivMobileHeaderTitle>{props.title}</DivMobileHeaderTitle>
              <DivMobileHeaderBack></DivMobileHeaderBack>
            </DivMobileHeader>
            <div className={`contentWrapper${isLoading ? " loading" : ""}`}>
              <div className="videoGallery">
                {
                  isLoading ? videoData.map((d: any, idx:number)=>
                    <Grid item lg={12} key={idx}>
                      <Skeleton key={idx} animation="wave" variant="rounded" width="100%" height={94} sx={{marginBottom: "12px", borderRadius: "8px", boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.1)", backgroundColor: "white"}} />
                    </Grid>
                  ) :
                  videoData.map((item: VideoInfo | undefined, idx: number) => {
                    if (item === undefined || !item.isValid) return;
                    return (
                      <Grid item lg={12} key={idx}>
                        <VideoThumbnail variant="list" {...item} enableShare={props.enableShare} onClick={(e)=>openVideoPlayer(e, idx)} />
                      </Grid>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </Modal>
      ) : (
        <div className={`videoGalleryContainer${isLoading ? " loading" : ""}`}>
          <Grid className="videoGallery" container>
          {
            isLoading ? videoData.map((d: any, idx:number)=>
              <Grid item lg={4} key={idx}>
                <Skeleton key={idx} animation="wave" variant="rectangular" width="auto" height={226} sx={{margin: "20px 10px", borderRadius: "0px 0px 4px 4px", boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.1)"}} />
              </Grid>
            ) :
            videoData.map((item: VideoInfo | undefined, idx: number) => {
              if (item === undefined || !item.isValid) return;
              return (
                <Grid item lg={4} key={idx}>
                  <VideoThumbnail {...item} enableShare={props.enableShare} onClick={(e)=>openVideoPlayer(e, idx)} />
                </Grid>
              )
            })
          }
          </Grid>
        </div>
      )
    }
    <VideoPlayer WAData={selectedWAData} titleSx={{backgroundColor: 'transparent', '& div': {padding: '0px 12px', textAlign: 'left !important'}, '& .closeBtn': {margin: '4px 0px'}}} title={selectedVideoTitle} sources={selectedSources} open={isOpenVideo} isMobile={props.isMobile} isEmbed={!props.isMobile} width="100%" height="100%" handleClose={handleClose} showCurrentTooltip showHoveredTooltip autoPlay />
  </>
  )
}

export default VideoGallery;